import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import BaseURLs from '../../../assets/scripts/UrlApi.json';
import { BackEndURLSettings } from './backEndUrlSettings';

@Injectable({
  providedIn: 'root'
})
export class BackendurlService {
  static settings: BackEndURLSettings = <BackEndURLSettings>({});

  constructor(private _injector: Injector, private httpclient:HttpClient) {}
  /* get http() {
    return this._injector.get(HttpClient);
  }
    loadConfig():Observable<BackEndURLSettings> {
      const jsonFile = 'assets/scripts/UrlApi.json';
      return this.httpclient.get<BackEndURLSettings>(jsonFile).pipe(
        map((res:BackEndURLSettings) => {
          BackendurlService.settings = {...res};
          return res;
        })
      );
    }
 */
  get barcloudUrl():string{
      return BaseURLs.barcloudUrl;
  }
  get url():string{
    return BaseURLs.barcloudUrl;
  }
  get enterpriseApi():string{
    return BaseURLs.enterpriseApi;
  }
  get barcloudUrlLocal():string{
    return BaseURLs.barcloudUrlLocal;
  }
  get urlLocal():string{
    return BaseURLs.urlLocal;
  }
  get enterpriseApiLocal():string{
    return BaseURLs.enterpriseApiLocal;
  }
  get releaseNoteUrl(): string {
    return (BaseURLs as any).releaseNoteUrl || '';
  }
  get contactUsUrl(): string {
    return (BaseURLs as any).contactUsUrl || '';
  }
  get companyUrl(): string {
    return (BaseURLs as any).companyUrl || '';
  }
  get supportUrl(): string {
    return (BaseURLs as any).supportUrl || '';
  }
  get returnPolicyUrl(): string {
    return (BaseURLs as any).returnPolicyUrl || '';
  }
  get privacyPolicyUrl(): string {
    return (BaseURLs as any).privacyPolicyUrl || '';
  }
  get termsOfServiceUrl(): string {
    return (BaseURLs as any).termsOfServiceUrl || (BaseURLs as any).termsAndConditionsUrl || '';
  }
  get termsAndConditionsUrl(): string {
    return (BaseURLs as any).termsAndConditionsUrl || (BaseURLs as any).termsOfServiceUrl || '';
  }
  get wikiUrl(): string {
    return BackendurlService.settings?.wikiUrl || (BaseURLs as any).wikiUrl || 'https://www.asapsystems.com/wiki/barcloud/';
  }
  get videoUrl(): string {
    return BackendurlService.settings?.videoUrl || (BaseURLs as any).videoUrl || 'https://www.youtube.com/@ASAPSystems';
  }
  get contactSupportUrl(): string {
    return BackendurlService.settings?.contactSupportUrl || BackendurlService.settings?.supportUrl || (BaseURLs as any).contactSupportUrl || (BaseURLs as any).supportUrl || 'https://www.asapsystems.com/inventory-asset-tracking-support/';
  }
  get scheduleTrainingUrl(): string {
    return BackendurlService.settings?.scheduleTrainingUrl || (BackendurlService.settings as any)?.trainingUrl || (BaseURLs as any).scheduleTrainingUrl || (BaseURLs as any).trainingUrl || 'https://outlook.office365.com/owa/calendar/ASAPSystemsTrainingandSupport@asapsystems.com/bookings/';
  }

}
/*
@Injectable({
  providedIn: 'root'
})
export class BackendurlServiceBase {
  constructor(private http: HttpClient) {}
  getSettings():Observable<BackEndURLSettings> {
    const jsonFile = 'assets/scripts/UrlApi.json';
    return this.http.get<BackEndURLSettings>(jsonFile).pipe(
      map((res:BackEndURLSettings) => {return res;})
    );
  }
}
*/
